import { LeaveApprovals } from "components/leaveApprovals/types";

export interface LeaveRequestsFilters {
  page: number;
  limit?: number;
  searchParams?: {
    requestType?: string;
    approved?: string;
    year?: string;
    requestBy?: string;
    startDate?: string;
    endDate?: string;
  };
}

export interface LeaveRequestsPaginatedResponse {
  data: LeaveApprovals[];
  total: number;
  total_pages: number;
  page: number;
  limit: number;
}

export const ITEMS_PER_PAGE_DEFAULT = 10;
